import React from "react";
import { withJsonFormsLayoutProps } from "@jsonforms/react";
import { rankWith, schemaMatches } from "@jsonforms/core";

const GenericComponentRenderer = (props) => {
  const { component: Component, componentProps } = props.uischema.options;

  if (!Component || typeof Component !== "function") {
    return null;
  }

  return <Component options={componentProps} data={props.data} {...props} />;
};

const genericComponentTester = rankWith(
  200,
  schemaMatches((schema) => schema.component)
);

export default withJsonFormsLayoutProps(GenericComponentRenderer);
export { genericComponentTester };
